import {
    __,
    compose,
    defaultTo,
    filter,
    head,
    includes,
    modify,
    propEq,
    propSatisfies,
    sortBy,
} from 'ramda';
import {
    PRECEDENCE_LOOKUP,
    VALID_SCOPES,
} from '../constants/environmentVariable.constants';
import { SETTINGS_ACCESSOR_CONFIG } from './settingsAccessor.config';

const isValidScope = includes(__, VALID_SCOPES);

const isValidEnvironmentVariable = propSatisfies(isValidScope, 'scope');

const environmentVariablePriority = ({ scope }) => PRECEDENCE_LOOKUP[scope];

const findEnvironmentVariable = (key, environmentVariables) =>
    compose(
        defaultTo(null),
        head,
        sortBy(environmentVariablePriority),
        filter(isValidEnvironmentVariable),
        filter(propEq('key', key)),
    )(environmentVariables);

const settingsAccessor = ({
    environmentVariables = [],
    options = {},
    config = SETTINGS_ACCESSOR_CONFIG,
} = {}) => {
    const getEnvironmentVariable = (key) =>
        findEnvironmentVariable(key, environmentVariables);

    // option is used for string key/value settings set by the UseOption command.
    // config is for settings that are controlled in a more structured way by the FormsViewer code.

    const getOption = (key) => options[key];

    const setOption = (key, value) => (options[key] = value);

    const getConfig = (key) => config[key];

    const updateConfig = (key, updater) => {
        config = modify(key, updater, config);
    };

    return {
        getEnvironmentVariable,
        getOption,
        setOption,
        getConfig,
        updateConfig,
    };
};

export default settingsAccessor;
